module.exports = __webpack_public_path__ + "img/shorts.0ac7c613.svg";